import { Fragment } from 'react';
import type { NextPage } from 'next';
import { fadeInAnimate, slideInDownAnimate } from 'utils/animation';
import NextLink from 'components/reuseable/links/NextLink';
// -------- custom component -------- //
import { Hero1, Hero1Para } from 'components/blocks/hero';
import { Footer1 } from 'components/blocks/footer';
import { Process1 } from 'components/blocks/process';
import { seoAuditList1 } from 'data/process';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';
import { CTA5 } from 'components/blocks/call-to-action';
import { Services19 } from 'components/blocks/services';
import { serviceList9 } from 'data/service';

import Video from 'components/blocks/video/Video';

import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import howlongdoesanseoaudittake from 'data/all-pages-dynamic-content/london/seo-audit/how-long-does-an-seo-audit-take';
import howtodotechnicalseoaudit from 'data/all-pages-dynamic-content/london/seo-audit/how-to-do-technical-seo-audit';

const details = {
  pageName: 'SEO Audit London | Seo Audit Services',
  categories: 'seo, web design',
  description:
    'SEOptimist provides seo audit services to greatly improve your site ranking. Get your free technical SEO audit now from SEOptimist audit London',
  parentDirectories: ''
};

const seoAuditPage: NextPage = () => {
  return (
    <>
      {/* ========== SEO META values ========== */}
      <SEO
        title={`${All.SEOAudit[0].title}`}
        description={details.description}
        tag={details.categories}
        urlPT={``}
        urlENPT={``}
        url={`${All.SEOAudit[0].url}/${All.SEOAudit[0].title.toLowerCase().replace(/ /g, '-')}`}
        image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
        // updated=""
        // published=""
        // modified=""
      />

      {/* ========== heading section ========== */}
      <Fragment>
        <main className="content-wrapper bg-white">
          {/* ========== hero section ========== */}
          <div style={fadeInAnimate('900ms')}>
            <Video
              heading={All.SEOAudit[0].title}
              title1="SEO"
              title2="AUDIT"
              title3=""
              movie="/1.mp4"
              placeholder="1-bg.jpg"
              button="website-test"
              fontsize1={150}
              fontsize2={150}
              body=""
              intro=" helps London companies improve Google ranking with our free SEO audit. If&nbsp;you&nbsp;want to accelerate
              your business online, we are the experts using proprietary technology and AI."
            />
          </div>{' '}
          <div id="website-test-intro"></div>
          <Hero1
            bgcolor="bg-soft-primary mb-20"
            title={``}
            lead={``}
            body={[
              <div key={100} className="text-center" id="report">
                <p className="text-center fs-34 mb-0 mx-auto">
                  <strong>
                    GET YOUR FREE <span className="text-fuchsia">TECHNICAL SEO REPORT</span>
                  </strong>
                </p>
                <p className="text-center fs-18 mx-auto">
                  Action the findings from the report or purchase {All.HomeList[8].title}
                </p>
              </div>
            ]}
          />
          <div id="ai-seo"></div>
          {/* ========== AI SEO section ========== */}
          <section className="wrapper bg-dark angled wrapper angled upper-end mt-20 mb-0">
            <div className="container pb-5 pt-md-10 mb-md-10 text-light items-bg-light">
              <Process1
                title={``}
                subtitle={All.SEOAudit[4].title}
                body={[
                  <p className="lead text-light" key="100">
                    {`An SEO audit is an in-depth analysis of how well a website is optimised for search engines. It analyses how well a website performs in terms of search engine optimisation and suggests changes to be made. Finding out how your website is doing in terms of search engine optimisation and where there may be room for improvement is made much easier with the help of an SEO audit service.`}
                  </p>,
                  <p
                    className="lead text-light"
                    key="101"
                  >{`As the world becomes more digital, the way people search for information and products is constantly evolving. That's why we keep our client websites responsive to changes in how people search.  People change in the way they search - they're asking natural questions too. The future of search is creating new opportunities for you to promote your business very effectively.`}</p>,
                  <p className="lead text-light" key="102">
                    In addition to looking at the website's present standing in the search engine results pages, the
                    {All.SEOAudit[4].title} will also look at the competition and do keyword research. By doing so, we
                    can pinpoint any optimisation opportunities that could boost our exposure and position in search
                    engine results pages. In addition to identifying areas for improvement, the audit will suggest best
                    practises and optimisations that can be used to boost the site's overall performance.
                  </p>
                ]}
                list={seoAuditList1}
                buttonLink="/#contact"
                buttonTitle="Get in touch"
                displayButton={'d-none'}
                src=""
                alt={All.SEOAudit[0].title}
              />
            </div>
          </section>{' '}
          <section className="wrapper bg-white">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>
                    {All.SEOAudit[0].title}: {howlongdoesanseoaudittake[0].body}
                  </h2>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  {howlongdoesanseoaudittake.slice(1, howlongdoesanseoaudittake.length).map((item, index) => (
                    <Fragment key={index}>
                      {/* <div id={item.id}></div> */}
                      <div className="row">
                        <div className="col-md-12">
                          {/* <h2 className="display-4">{item.body}</h2> */}
                          <p className="lead">{item.body}</p>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                  <p>
                    <strong>SEOptimist</strong>
                  </p>
                </div>
                <div className="col-md-6">
                  <img
                    src={`/img/${All.SEOAudit[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                    alt={All.SEOAudit[0].title}
                    className="img-fluid"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              </div>
            </div>
          </section>
          <Services19 title={All.HomeList[9].title} serviceList={serviceList9} />
          <section className="wrapper bg-white mt-15">
            <div className="container">
              <div className="row">
                <div className="col-md-7 mx-auto">
                  <h2>{All.SEOAudit[5].title}</h2>
                  <h3>{howtodotechnicalseoaudit[2].body}</h3>
                </div>
              </div>
              {howtodotechnicalseoaudit.slice(3, 4).map((item, index) => (
                <Fragment key={index}>
                  {/* <div id={item.id}></div> */}
                  <div className="row">
                    <div className="col-md-7 mx-auto">
                      {/* <h2 className="display-4">{item.body}</h2> */}
                      <p className="lead">{item.body}</p>
                      <img
                        className="mw mt-5 mb-15"
                        src={'/img/' + All.SEOAudit[3].title.toLowerCase().replace(/ /g, '-') + '.png'}
                        alt={All.SEOAudit[3].title}
                      />
                    </div>
                    {/* {item.img ? (
                      <div className="col-md-6">
                        <div className="text-center">
                          <img
                            src={`/img/${item.img}`}
                            alt={item.body}
                            className="img-fluid rounded shadow-lg"
                            style={{ maxWidth: '100%' }}
                          />
                        </div>
                      </div>
                    ) : null} */}
                  </div>
                </Fragment>
              ))}
            </div>
          </section>
          <section className="wrapper bg-white pb-17">
            <div className="container">
              <div className="row">
                <div className="col-md-7 mx-auto">
                  <h2>{All.SEOAudit[8].title}</h2>
                  <h3>{howtodotechnicalseoaudit[4].body}</h3>
                </div>
              </div>
              {howtodotechnicalseoaudit.slice(5, howtodotechnicalseoaudit.length).map((item, index) => (
                <Fragment key={index}>
                  <div className="row">
                    <div className="col-md-7 mx-auto">
                      {/* <h2 className="display-4">{item.body}</h2> */}
                      <p className="lead">{item.body}</p>
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
          </section>
          {/* ========== GET A QUOTE section ========== */}
          <CTA5 body={`Join our happy clients with our ${All.HomeList[8].title} to grow your business.`} />
          {/* ========== Technical SEO London section ========== */}
          <section className="wrapper bg-white pb-17">
            <div className="container">
              <div className="row">
                <div className="col-md-7 mx-auto">
                  <h2>{All.SEOAudit[2].title}</h2>
                  <p>
                    Here at SEOptimist, our number one priority is to offer you the finest {All.SEOAudit[2].title}{' '}
                    available. Our SEO audit is a thorough evaluation of your site's existing optimisation levels.
                  </p>
                  <h3>{All.SEOAudit[3].title}</h3>
                  <p>
                    If you want more traffic to your ecommerce website, a higher search engine rating, and your site to
                    run more smoothly, you need to do an {All.SEOAudit[3].title}. An SEO audit is a comprehensive
                    analysis of your website's performance in search engines like Google. Our staff can assist you in
                    making these changes and optimising your content for search engines by detecting these aspects.
                  </p>
                  <p>
                    Here at SEOptimist, we take into account both on-page and off-page SEO criteria when conducting an
                    audit of your site. Our audit consists of a thorough examination of the following factors:
                  </p>
                  <h3>Organisation and Mapping of a Website</h3>
                  <p>
                    We check your site's architecture and menus to guarantee they're straightforward and simple to use.
                    We also look for technical problems that could be slowing down your site's performance and fix them
                    if we find any.
                  </p>
                  <h3>Keyword Research</h3>
                  <p>
                    We examine your website's keyword usage extensively to identify successful and underperforming
                    terms. You'll learn how to outrank the competition by doing keyword research on their sites and
                    finding gaps in their online presence.
                  </p>
                  <img
                    src={`/img/${All.SEOAudit[1].title.toLowerCase().replace(/ /g, '-')}.png`}
                    alt={All.SEOAudit[1].title}
                    className="mw mt-5 mb-13"
                  />
                  <h3>Examining the Content</h3>
                  <p>
                    We check your website's content for search engine optimisation and user interest to better serve
                    you. We also look for problems like broken links, missing pages, and duplicate material that could
                    be slowing down your site.
                  </p>
                  <h3>Domain Authority</h3>
                  <p>
                    We examine the profile of inbound links to your website to ascertain their quality and number. We
                    also investigate the possibility that low-quality or spammy links have been placed on your site.
                  </p>
                  <h3>Social Media</h3>
                  <p>
                    We take a look at your social media profiles to see if they are helping or hindering your search
                    engine optimisation. We also give you tips on how to make your social media efforts more in line
                    with your SEO objectives.
                  </p>
                  <p>
                    After performing an SEO audit, we will deliver a comprehensive report that details our findings and
                    suggestions for enhancing your website's search engine optimisation. We'll help you put these
                    suggestions into action and keep an eye on your site's performance as time goes on.
                  </p>
                  {/* <FAQ2
                title1="AUDIT"
                title2="FAQ"
                movie="technical-seo-agency.webm"
                placeholder="1-bg.jpg"
                body=""
                subtitle={All.HomeList[8].title}
                accordion={accordionList99}
                titleColor="muted"
                fontsize1={110}
                fontsize2={100}
              /> */}
                  <p>
                    At SEOptimist, we're committed to seeing you succeed in search engine optimisation. If you're
                    interested in our SEO audit services and how they can enhance your website's visibility and ranking,
                    we encourage you to get in touch with us right away.
                  </p>
                  <h2>{All.SEOAudit[5].title}</h2> {/*  technical SEO audit services */}
                  <p>
                    In the ever-evolving digital landscape, staying ahead of the competition requires a thorough
                    understanding of your website's technical performance, which might call for {All.SEOAudit[5].title}.
                    That's where SEOptimist, the{' '}
                    <NextLink
                      title={All.GoogleAnalytics[3].title}
                      href={
                        '/' +
                        All.GoogleAnalytics[0].url +
                        '/' +
                        All.GoogleAnalytics[0].title.toLowerCase().replace(/ /g, '-')
                      }
                    />
                    , comes in. As a trusted provider of {All.SEOAudit[5].title}, we help businesses like yours identify
                    and address potential issues that may be hindering your online visibility and organic rankings.
                  </p>
                  <h2>{All.SEOAudit[6].title}</h2> {/*  why SEO audit is important */}
                  <p>
                    You might wonder, {All.SEOAudit[6].title}? An SEO audit serves as a roadmap to optimize your website
                    and boost its visibility in search engine results pages (SERPs). It not only helps identify
                    technical issues that may be hampering your rankings but also provides valuable insights into
                    content optimization, backlink analysis, and overall website health. By conducting a thorough SEO
                    audit, our team of <NextLink title={All.HomeList[6].title} href={'/'} /> gives you a clear
                    understanding of your website's strengths and weaknesses, enabling you to implement targeted
                    strategies that enhance its performance and drive organic traffic. To truly decipher how you can
                    optimize your website and boost your business is {All.SEOAudit[6].title}.
                  </p>
                  <h2>{All.SEOAudit[7].title}</h2> {/*  SEO tech audit */}
                  <p>
                    A {All.SEOAudit[7].title} is a comprehensive evaluation of your website's technical infrastructure,
                    aiming to uncover any underlying issues that may impact its search engine performance. Our team of
                    experts conducts a meticulous examination of various technical elements, including website speed,
                    mobile-friendliness, site structure, URL structure, indexing, and crawlability, among others. By
                    analyzing these factors, we identify areas for improvement and provide actionable recommendations to
                    enhance your website's technical foundation. SEOptimist proposes various ways of conducting a{' '}
                    {All.SEOAudit[7].title} and offers a wide range of{' '}
                    <NextLink
                      title={All.EcommerceSEO[9].title}
                      href={
                        '/' + All.EcommerceSEO[9].url + '/' + All.EcommerceSEO[9].title.toLowerCase().replace(/ /g, '-')
                      }
                    />
                    s, adapted to each customer.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <ContactFooterCombo location="london" />
      </Fragment>
    </>
  );
};

export default seoAuditPage;
